import React, { useContext, useEffect, useState } from 'react';
import '../TaskBoard/TaskBoard.css';

import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import Modal from "react-modal";
import Select from 'react-select';
import { BiSortAlt2 } from "react-icons/bi";
import { PiCircle } from "react-icons/pi";
import { CategoryScale, Chart } from "chart.js";
import animation from "../../../assets/lottie/Animation - 1720435076782.json"
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { GET, PUT } from '../../Common/HttpMethods/HttpMethods';
import { Url } from '../../../constants/ApiUrlConstants';
import { contextData } from '../../../context/ContextProvider';
import { BsSearch } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import FileUpload from '../../Other/FileUpload';
import FailModal from '../../Common/Popups/FailModal';
import moment from 'moment';
import SuccessModal from '../../Common/Popups/SuccessModal';
import { CustomDatePicker, TaskCard, TaskboardTable, createTableIcons, modalStyles, customStyles, StatusSelector, Cuurent_USER_ROLES, Cuurent_StaffId } from '../../CommonCase/CommonFunctions';
import { IoMdClose } from 'react-icons/io';
import Lottie from 'lottie-react';

// Function to handle the logic when 'org' is true
export const handleOrgTasks = ({
  org,
  fetchData,
  setTaskCount,
  setTaskPercentage,
  taskCount,
  taskPercentage,
  Url,
  setAdminTaskDue,
  setAllEmployeeOptions,
}) => {
  if (org) {
             getGraphCount({
                    fetchData,
                    setTaskCount,
                    setTaskPercentage,
                    taskCount,
                    taskPercentage,
                    Url,
                });
                getDueTasksForAdmin({
                    fetchData,
                    Url,
                    setAdminTaskDue,
                });
                getEmployeeData1({
                    fetchData,
                    setAllEmployeeOptions,
                    Url,
                });
  }
};


export const handleEmpChange = async (selectedOption, {
    setFilterValue,
    setSelectedEmp,
    setLoading,
    GET,
    Url,
    token,
    taskCount,
    setTaskCount,
    taskPercentage,
    setTaskPercentage,
    setAdminTaskDue,
    setSessionExpiredModal,
    setFailMessage,
    setOpenFailModal,
}) => {
    setFilterValue(null);
    setSelectedEmp(selectedOption);
    const empId = selectedOption?.value === "All" ? selectedOption?.value : selectedOption.value.staffId;
    try {
        setLoading(true);
        const getEmployeeGraphCountresp = await GET(Url.getEmployeeGraphCount.replace("{employeeId}", empId), token);
        if (getEmployeeGraphCountresp.SUCCESS) {
            setLoading(false);
            setTaskCount({
                ...taskCount,
                NotStartedCount: getEmployeeGraphCountresp?.DATA?.NotStartedCount,
                CompletedTaskCount: getEmployeeGraphCountresp?.DATA?.CompletedTaskCount,
                OverDueTaskCount: getEmployeeGraphCountresp?.DATA?.OverDueTaskCount,
                PendingTaskCount: getEmployeeGraphCountresp?.DATA?.PendingTaskCount,
            });
            setTaskPercentage({
                ...taskPercentage,
                PendingPercentage: getEmployeeGraphCountresp?.DATA?.PendingPercentage,
                CompletedPercentage: getEmployeeGraphCountresp?.DATA?.CompletedPercentage,
                OverduePercentage: getEmployeeGraphCountresp?.DATA?.OverduePercentage,
                NotStartedPercentage: getEmployeeGraphCountresp?.DATA?.NotStartedPercentage,
            });
            setAdminTaskDue(getEmployeeGraphCountresp?.DATA?.OverDueTask);
        } else if (getEmployeeGraphCountresp.STATUS === 401) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else if (getEmployeeGraphCountresp.STATUS === 400) {
          setLoading(false);
          setSessionExpiredModal(true);
          setFailMessage("Session expired");
      } else if (getEmployeeGraphCountresp.STATUS === 403) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
    } else if (getEmployeeGraphCountresp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
  } else if (getEmployeeGraphCountresp.STATUS === 500) {
    setLoading(false);
    setSessionExpiredModal(true);
    setFailMessage("Session expired");
} else {
            setLoading(false);
            setFailMessage("Failed to fetch Taskboard grid data.");
            setOpenFailModal(true);
        }
    } catch (error) {
        setLoading(false);
        setFailMessage("Failed to fetch task list.");
        setOpenFailModal(true);
    }
};


export const navigateAfterSubmit = (navigate) => {
  navigate("/main/taskboard");
};

export const isOverflowing=(element) =>{
  return element?.scrollWidth > element?.clientWidth;
}

export const handleRequestClose = (setIsView, setTaskDetailModal) => {
  setIsView(false);
  setTaskDetailModal(false);
};

export const adjustTextareaHeight = () => {
    const element = document.getElementById('taskDescription')
    element.style.height = 'auto';
    element.style.height = element?.scrollHeight + 'px';
};

export const exportedHandleStatusChange = (
    selectedOption,
    { setTaskError, setDataToEdit, dataToEdit }
) => {
    const newStatus = selectedOption?.value;
    if (newStatus === 'Completed') {
        if (!dataToEdit?.taskDescription || !dataToEdit?.taskDescription.trim()) {
            setTaskError("Please add a description.");
        } else {
            setTaskError("");
        }
    } else {
        setTaskError("");
    }
    setDataToEdit({ ...dataToEdit, taskStatus: newStatus });
};

export const handleDescriptionChange = (
    event,
    { setDataToEdit, setTaskError, dataToEdit }
) => {
    const description = event.target.value;
    setDataToEdit({ ...dataToEdit, taskDescription: description });

    if (dataToEdit?.taskStatus === 'Completed') {
        if (/^\s/.test(description)) {
            setTaskError("Please add a description without leading spaces.");
        } else {
            setTaskError("");
        }
    } else {
        setTaskError("");
    }

    if (description && /^\s/.test(description)) {
        setTaskError("Please add a description without leading spaces.");
    } else {
        setTaskError("");
    }
};

export const handleDivEvent = (e, isView) => {
    if (isView) {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  

export const adjustTextareaHeight1 = (setLoading, getElementById) => {
    setLoading(true);
    setTimeout(() => {
        const element = getElementById('taskDescription');
        if (element) {
            element.style.height = 'auto';
            element.style.height = element.scrollHeight + 'px';
        }
        setLoading(false);
    }, 1000);
};

export const getActionItemDataById = (
    id,
    fetchData,
    setTaskStatus,
    setTaskDetailModal,
    setTaskError,
    setDataToEdit,
    setActualData,
    setLoading,
    getElementById,
    adjustTextareaHeight1
) => {
    fetchData(
        Url.getTaskById.replace('{id}', `${id}`),
        (data) => {
            setTaskStatus(data?.taskStatus);
            setTaskDetailModal(true);
            setTaskError("");

            let actualFileData = [];
            let editFileData = [];

            data?.actionAttachments?.forEach((f) => {
                actualFileData.push({
                    name: f?.fileName,
                    fileType: f?.fileType,
                    attachment: f?.attachment,
                    attachmentDocId: f?.attachmentDocId
                });

                editFileData.push({
                    fileName: f?.fileName,
                    fileType: f?.fileType,
                    attachment: f?.attachment,
                    attachmentDocId: f?.attachmentDocId
                });
            });

            let obj = {
                ...data,
                formattedAssignedDate: new Date(data?.parsedAssignedDate),
                formattedEtaDate: new Date(data?.parsedEtaDate),
                attachmentDocuments: [...editFileData],
                formattedClosingDate: new Date(data?.parsedClosingDate)
            };

            setDataToEdit(obj);
            setActualData([...actualFileData]);
            adjustTextareaHeight1(setLoading, getElementById);
        },
        "Failed to fetch minutes."
    );
};

export const handleEditTask = async (
    dataToEdit,
    setLoading,
    setTaskError,
    PUT,
    Url,
    token,
    moment,
    ActiveTBbutton,
    getTableData,
    getSortedTaskData,
    setOpenSuccessModal,
    setSuccessMessage,
    setTaskDetailModal,
    setSessionExpiredModal,
    setFailMessage,
    setOpenFailModal,
    setSearchInput,
    setProgress
) => {
    try {
        setLoading(true);

        if (dataToEdit?.taskStatus === "Completed") {
            const originalDescription = dataToEdit?.taskDescription;

            if (!originalDescription) {
                setTaskError("Please add a description.");
                return;
            }
            const trimmedDescription = originalDescription.trim();

            if (/^\s/.test(originalDescription)) {
                setTaskError("Please add a valid description without leading spaces.");
                return;
            }
        } else if (dataToEdit?.taskStatus !== "Completed") {
            const originalDescription = dataToEdit?.taskDescription;
            if (originalDescription && /^\s/.test(originalDescription)) {
                setTaskError("Please add a description without leading spaces.");
                return;
            } else {
                setTaskError("");
            }
        }

        const body = {
            ...dataToEdit,
            actionAttachments: dataToEdit?.attachmentDocuments,
            assignedDate: moment(dataToEdit?.formattedAssignedDate).format('YYYY-MM-DD'),
            etaDate: moment(dataToEdit?.formattedEtaDate).format('YYYY-MM-DD'),
        };

        const editTaskResp = await PUT(Url.updateTask, token, body);

        if (editTaskResp?.SUCCESS) {
            if (ActiveTBbutton == 2) {
                // Any additional code for ActiveTBbutton === 2 case
            }
            getTableData();
            getSortedTaskData();
            setOpenSuccessModal(true);
            setSuccessMessage("Task updated successfully.");
            setTaskDetailModal(false);
            setSearchInput("");
            setProgress("")
        } else if (editTaskResp?.STATUS === 401) {
            setSessionExpiredModal(true);
            setFailMessage("Session expired.");
        }else if (editTaskResp?.STATUS === 400) {
          setSessionExpiredModal(true)
          setFailMessage("The request was invalid.")
        }else if (editTaskResp?.STATUS === 403) {
          setSessionExpiredModal(true)
          setFailMessage("You do not have access.")
        }else if (editTaskResp?.STATUS === 404) {
          setSessionExpiredModal(true)
          setFailMessage("The resource could not be found.")
        }else if (editTaskResp?.STATUS === 500) {
          setSessionExpiredModal(true)
          setFailMessage("Something went wrong on the server")
        }else {
            setFailMessage("Failed to edit task. Please try again.");
            setOpenFailModal(true);
        }
    } catch (error) {
        console.error("Error while handling edit:", error);
        setFailMessage("Failed to edit task. Please try again.");
        setOpenFailModal(true);
    } finally {
        setLoading(false);
    }
};

export const SortingToggle = (sortedData, setSortedData, isAscendingPend, setIsAscendingPend) => {
    setIsAscendingPend(!isAscendingPend);

    let data1 = { ...sortedData };
    sortedData?.PendingTask?.sort((a, b) =>
        isAscendingPend
            ? new Date(a?.etaDate) - new Date(b?.etaDate)
            : new Date(b?.etaDate) - new Date(a?.etaDate)
    );
    setSortedData(data1);
};

export const SortingToggle2 = (sortedData, setSortedData, isAscendingComp, setIsAscendingComp) => {
    setIsAscendingComp(!isAscendingComp);

    let data1 = { ...sortedData };
    sortedData?.CompletedTask?.sort((a, b) =>
        isAscendingComp
            ? new Date(a?.closingDate) - new Date(b?.closingDate)
            : new Date(b?.closingDate) - new Date(a?.closingDate)
    );
    setSortedData(data1);
};

export const SortingToggle3 = (sortedData, setSortedData, isAscendingOver, setIsAscendingOver) => {
    setIsAscendingOver(!isAscendingOver);

    let data1 = { ...sortedData };
    sortedData?.OverDueTask?.sort((a, b) =>
        isAscendingOver
            ? new Date(a?.etaDate) - new Date(b?.etaDate)
            : new Date(b?.etaDate) - new Date(a?.etaDate)
    );
    setSortedData(data1);
};



export const handleUserFilterValueChange = (e, setFilterValue) => {
  console.log("Filter in", e)
    setFilterValue(e);
};

export const handleUserSwitch = (ActiveTBbutton, setUserSwitch, getSortedTaskData, getTableData) => {
    setUserSwitch(false);
    if (ActiveTBbutton === 2) {
        getSortedTaskData();
    } else if (ActiveTBbutton === 1) {
        getTableData();
    }
};

export const handleOrgSwitch = (ActiveTBbutton, setUserSwitch, getPerson, getAdminTaskList) => {
    setUserSwitch(true);
    if (ActiveTBbutton === 2) {
        getPerson();
    } else if (ActiveTBbutton === 1) {
        getAdminTaskList();
    }
};


export const handleEditChange2 = (name, value, setDataToEdit) => {
  console.log("11111111111111", value, )
  console.log("2",name, )
  console.log("3", setDataToEdit)
    if (name === "attachmentDocuments") {
        setDataToEdit((prevState) => {
            return {
                ...prevState,
                attachmentDocuments: [...prevState?.attachmentDocuments, ...value],
            };
        });
    }
};


export const handleClearSelection = ({ setSelectedEmp, handleEmpChangeWrapper, setFilterValue }) => {
    setSelectedEmp({ value: 'All', label: 'All Employees' });
    handleEmpChangeWrapper({ value: 'All', label: 'All Employees' });
    setFilterValue(null);
};


export const getEmployeeData1 = async ({ fetchData, setAllEmployeeOptions, Url }) => {
    const successCallback = (data) => {
        const options1 = data?.map((employee) => ({
            value: employee,
            label: employee.fullName,
        }));

        const allOption = {
            value: 'All',
            label: 'All Employees',
        };

        const finalOptions = [allOption, ...options1];

        setAllEmployeeOptions(finalOptions);
    };

    await fetchData(Url.getEmployees, successCallback, "Failed to fetch Audit Table data.");
};

export const getGraphCount = async ({ fetchData, setTaskCount, setTaskPercentage, taskCount, taskPercentage, Url }) => {
    const successCallback = (data) => {
        setTaskCount({
            ...taskCount,
            NotStartedCount: data?.NotStartedCount,
            CompletedTaskCount: data?.CompletedTaskCount,
            OverDueTaskCount: data?.OverDueTaskCount,
            PendingTaskCount: data?.PendingTaskCount,
        });
        setTaskPercentage({
            ...taskPercentage,
            PendingPercentage: data?.PendingPercentage,
            CompletedPercentage: data?.CompletedPercentage,
            OverduePercentage: data?.OverduePercentage,
            NotStartedPercentage: data?.NotStartedPercentage,
        });
    };

    await fetchData(Url.getGraphCount, successCallback, "Failed to fetch Taskboard grid data.");
};


export const getEmployeeGraphCount = async ({
    fetchData,
    Url,
    staffIdSession,
    setTaskCount,
    setTaskPercentage,
    setAdminTaskDue,
    taskCount,
    taskPercentage,
}) => {
    const url = Url.getEmployeeGraphCount.replace("{employeeId}", staffIdSession);

    const successCallback = (data) => {
        setTaskCount({
            ...taskCount,
            NotStartedCount: data?.NotStartedCount,
            CompletedTaskCount: data?.CompletedTaskCount,
            OverDueTaskCount: data?.OverDueTaskCount,
            PendingTaskCount: data?.PendingTaskCount,
        });

        setTaskPercentage({
            ...taskPercentage,
            PendingPercentage: data?.PendingPercentage,
            CompletedPercentage: data?.CompletedPercentage,
            OverduePercentage: data?.OverduePercentage,
            NotStartedPercentage: data?.NotStartedPercentage,
        });

        setAdminTaskDue(data?.OverDueTask);
    };

    await fetchData(url, successCallback, "Failed to fetch Taskboard grid data.");
};

export const getEmployeeGraphCountByFilter = async ({
    fetchData,
    Url,
    Cuurent_StaffId,
    selectedEmp,
    org,
    filterValue,
    setTaskCount,
    setTaskPercentage,
    taskCount,
    taskPercentage,
}) => {
    let selected_emp;

    if (org) {
        selected_emp =
            selectedEmp?.value === "All"
                ? selectedEmp?.value
                : selectedEmp?.value?.staffId;
    } else {
        selected_emp = Cuurent_StaffId();
    }

    const filtertype = filterValue?.value;
    const url = Url.getEmployeeGraphCountByFilter
        .replace("{employeeId}", selected_emp)
        .replace("{type}", filtertype);

    const successCallback = (data) => {
        setTaskCount({
            ...taskCount,
            NotStartedCount: data?.NotStartedCount,
            CompletedTaskCount: data?.CompletedTaskCount,
            OverDueTaskCount: data?.OverDueTaskCount,
            PendingTaskCount: data?.PendingTaskCount,
        });

        setTaskPercentage({
            ...taskPercentage,
            PendingPercentage: data?.PendingPercentage,
            CompletedPercentage: data?.CompletedPercentage,
            OverduePercentage: data?.OverduePercentage,
            NotStartedPercentage: data?.NotStartedPercentage,
        });
    };

    await fetchData(url, successCallback, "Failed to fetch Taskboard grid data.");
};

export const getDueTasksForAdmin = async ({
    fetchData,
    Url,
    setAdminTaskDue,
}) => {
    const url = Url.getDueTasksForAdmin;

    const successCallback = (data) => {
        setAdminTaskDue(data?.OverDueTask);
    };

    await fetchData(url, successCallback, "Failed to fetch Taskboard grid data.");
};


export const getFilteredData = ({
    fetchData,
    Url,
    progress,
    setTableData,
    setTableDataCopy,
}) => {
    fetchData(
        Url.gettaskboardFilteredData + progress?.value,
        (data) => {
            setTableData(data);
            setTableDataCopy(data);
        },
        "Failed to fetch Taskboard table data."
    );
};

export const getPersonalFilterData = ({
    fetchData,
    Url,
    progress,
    setTableData,
    setTableDataCopy,
}) => {
    fetchData(
        Url.getPersonalTaskListByStatus.replace("{status}", progress?.value),
        (data) => {
            setTableData(data);
            setTableDataCopy(data);
        },
        "Failed to fetch Taskboard table data."
    );
};


export const filterTableDataBySearchInput = (searchInput, tableDataCopy, setTableData) => {
    if (searchInput === "") {
        setTableData(tableDataCopy);
    } else {
        setTableData(
            tableDataCopy?.filter((i) =>
                i?.taskName?.toLowerCase()?.includes(searchInput.toString()?.toLowerCase())
            )
        );
    }
};

export const handleProgressChange = ({
    ActiveTBbutton,
    progress,
    userSwitch,
    getTableData,
    getFilteredData,
    getPersonalFilterData,
    fetchData,
    Url,
    setTableData,
    setTableDataCopy,
}) => {
    if (ActiveTBbutton === 1) {
        if (progress.value === "") {
            getTableData();
        } else if (progress.value === "All" && !userSwitch) {
            getTableData();
        } else if (progress.value === "All" && userSwitch) {
            getPersonalFilterData({
                fetchData,
                Url,
                progress,
                setTableData,
                setTableDataCopy,
            });
        } else {
            if (userSwitch) {
                getPersonalFilterData({
                    fetchData,
                    Url,
                    progress,
                    setTableData,
                    setTableDataCopy,
                });
            } else {
                getFilteredData({
                    fetchData,
                    Url,
                    progress,
                    setTableData,
                    setTableDataCopy,
                });
            }
        }
    }
};

export const handleCloseFailModel = (setOpenFailModal) => {
    setOpenFailModal(false);
};

export const handleSessionExpClose = (sessionStorage, navigate, setActive) => {
    sessionStorage.clear();
    navigate('/login');
    setActive('tab1');
};

export const navigateToMeeting = (id, setViewPastMeeting, setFromPastMeeting, navigate) => {
    setViewPastMeeting({ isView: true, meetingId: id });
    setFromPastMeeting('taskboard');
    navigate("/main/meetings/my-meetings");
};



const TaskBoard = () => {
    const token = sessionStorage.getItem("TOKEN");
    const datePickerStyles = { color: 'hsl(0, 0%, 80%)', border: '1px solid black' };
    const datePickerEtaStyles = { ...datePickerStyles, fontSize: '14px' };
    const { setLoading, setViewPastMeeting, setActive, setFromPastMeeting, setActiveTBbutton, ActiveTBbutton, NavFromTBoard, setNavFromTBoard } = useContext(contextData);
    const navigate = useNavigate();


    Chart.register(CategoryScale);
    const total = 100;
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [sortedData, setSortedData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [tableDataCopy, setTableDataCopy] = useState([]);
    const [openFailModal, setOpenFailModal] = useState(false);
    const [failMessage, setFailMessage] = useState("");
    const [sessionExpiredModal, setSessionExpiredModal] = useState(false)

    const [isAscendingPend, setIsAscendingPend] = useState(true);
    const [isAscendingComp, setIsAscendingComp] = useState(true);
    const [isAscendingOver, setIsAscendingOver] = useState(true);

    const [TaskDetailModal, setTaskDetailModal] = useState(false);
    const [org, setOrg] = useState(false);
    const [searchInput, setSearchInput] = useState("")
    const [isView, setIsView] = useState(false);
    const [taskStatus, setTaskStatus] = useState("")
    const [userSwitch, setUserSwitch] = useState(false);
    const [taskError, setTaskError] = useState("")
    const [selectedEmp, setSelectedEmp] = useState(
        { value: 'All', label: 'All Employees' });



    //    ==========================================================charts API integration=====================================================
    const [taskCount, setTaskCount] = useState({
        NotStartedCount: "",
        CompletedTaskCount: "",
        OverDueTaskCount: "",
        PendingTaskCount: ""
    })

    const [taskPercentage, setTaskPercentage] = useState({
        PendingPercentage: "",
        CompletedPercentage: "",
        OverduePercentage: "",
        NotStartedPercentage: ""
    })

    const [AdminDueTask, setAdminTaskDue] = useState([])



    const [filterValue, setFilterValue] = useState(null)

    const [employeeOptions, setAllEmployeeOptions] = useState([])



    const UserFilterOptions = [
        { label: 'Today', value: 'Today' },
        { label: 'Tomorrow', value: 'Tomorrow' },
        { label: 'This Week ', value: 'This Week' },
        { label: 'Next Week', value: 'Next Week' },

    ]



    useEffect(() => {
        if (ActiveTBbutton === 3) {

            if (org) {
                // getGraphCount({
                //     fetchData,
                //     setTaskCount,
                //     setTaskPercentage,
                //     taskCount,
                //     taskPercentage,
                //     Url,
                // });
                // getDueTasksForAdmin({
                //     fetchData,
                //     Url,
                //     setAdminTaskDue,
                // });
                // getEmployeeData1({
                //     fetchData,
                //     setAllEmployeeOptions,
                //     Url,
                // });
                handleOrgTasks({
                  org,
                  fetchData,
                  setTaskCount,
                  setTaskPercentage,
                  taskCount,
                  taskPercentage,
                  Url,
                  setAdminTaskDue,
                  setAllEmployeeOptions,
                });
                   } else {
                getEmployeeGraphCount({
                    fetchData,
                    Url,
                    staffIdSession,
                    setTaskCount,
                    setTaskPercentage,
                    setAdminTaskDue,
                    taskCount,
                    taskPercentage,
                });

            }

        }
    }, [ActiveTBbutton]);

    useEffect(() => {
        ActiveTBbutton == 3 && getEmployeeGraphCountByFilter({
            fetchData,
            Url,
            Cuurent_StaffId,
            selectedEmp,
            org,
            filterValue,
            setTaskCount,
            setTaskPercentage,
            taskCount,
            taskPercentage,
        });
    }, [filterValue])

    const staffIdSession = Cuurent_StaffId();

    // =====================================================================Other API integration============================================================

    const fetchData = async (url, successCallback, failMessage) => {
        try {

            setLoading(true);

            const response = await GET(url, token);
            if (response.SUCCESS) {
                successCallback(response.DATA);
                setLoading(false);
            } else if (response.STATUS === 401) {

                setLoading(false);
                setSessionExpiredModal(true);
                setFailMessage("Session expired");
            } else {

                setLoading(false);
                setFailMessage(failMessage);
                setOpenFailModal(true);
            }
        } catch (error) {

            setLoading(false);
            setFailMessage(failMessage);
            setOpenFailModal(true);
        }
    };

    
     const handleEditChange = (name, value) => {
      console.log("11111111111111", value, )
      console.log("2",name, )
      console.log("3", setDataToEdit)
        if (name === "attachmentDocuments") {
            setDataToEdit((prevState) => {
                return {
                    ...prevState,
                    attachmentDocuments: [...prevState?.attachmentDocuments, ...value],
                };
            });
        }
    };

    const getTableData = () => {
      setLoading(true);
        fetchData(
            Url.getAllTaskList,
            (data) => {

                setTableData(data);
                setTableDataCopy(data);
            },
            "Failed to fetch Taskboard table data."
        );
        setLoading(false);
    };

    const getSortedTaskData = () => {
        fetchData(
            Url.getTaskBoard,
            (data) => {

                setSortedData(data);
            },
            "Failed to fetch Taskboard grid data."
        );
    };



    const colors = ['rgb(0, 173, 238)', 'rgb(34, 195, 115)', 'rgb(255, 139, 22)', 'rgb(235, 73, 93)'];

    const allZeros = (arr) => arr.every(value => value === 0);




    const dataset = {
        series: [{
            name: 'Tasks',
            colorByPoint: true,
            data: [
                {
                    name: 'In Progress',
                    y: (taskPercentage?.PendingPercentage ?? 0) / 100 * total,
                },
                {
                    name: 'Completed',
                    y: (taskPercentage?.CompletedPercentage ?? 0) / 100 * total,
                },
                {
                    name: 'Not Started',
                    y: (taskPercentage?.NotStartedPercentage ?? 0) / 100 * total,
                },
                {
                    name: 'Overdue',
                    y: (taskPercentage?.OverduePercentage ?? 0) / 100 * total,
                },
            ],
        }],
        chart: {
            type: 'pie',
            height: 350,
            width: 350,
            backgroundColor: null,
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
        },
        title: {
            text: null,
        },
        plotOptions: {
            pie: {
                innerSize: '50%',
                size: '45%',
                center: ['40%', '55%'],
                dataLabels: {
                    enabled: true,
                    format: '{point.name}: {point.percentage:.1f}%',
                    distance: 30,
                    connectorPadding: 10,
                    style: {
                        color: '#000000',
                        fontSize: '14px',
                        fontWeight: 'light',
                        textOverflow: 'clip'
                    }
                },
            },
        },
        tooltip: {
            formatter: function () {
                return `${this.point.name}: ${Highcharts.numberFormat(this.point.percentage, 1)}%`;
            },
        },
        colors: colors,
        credits: {
            enabled: false,
        },
    };






    const [dataToEdit, setDataToEdit] = useState(
        {
            actionItemId: "",
            assignedBy: "",
            assignedDate: new Date(),
            assignedTo: "",
            closingDate: new Date(),
            etaDate: new Date(),
            parsedAssignedDate: "",
            parsedClosingDate: "",
            parsedEtaDate: "",
            scheduleMeeting: "",
            taskDescription: "",
            taskName: "",
            taskStatus: ""
        }
    );

    const [actualData, setActualData] = useState([]);

    const [progress, setProgress] = useState("")

    const filterProgress = [
        { value: "All", label: "All" },
        { value: "Not Started", label: "Not Started" },
        { value: "In Progress", label: "In Progress" },
        { value: "Completed", label: "Completed" },
    ]



    // =======================================================================toggle switch functionality==============================================================

    const getPerson = () => {
        fetchData(
            Url.getAdminPersonalTaskBoard,
            (data) => {
                setSortedData(data);

            },
            "Failed to fetch Taskboard grid data."
        );
    };

    const getAdminTaskList = () => {
        fetchData(
            Url.getAdminPersonalTaskList,
            (data) => {

                setTableData(data);
                setTableDataCopy(data);

            },
            "Failed to fetch Taskboard table data."
        );
    };



    // function isOverflowing(element) {
    //     return element?.scrollWidth > element?.clientWidth;
    // }

    useEffect(() => {

    }, [dataToEdit])

    useEffect(() => {
        setTimeout(() => {

            let div1 = document.getElementById('MeetingSub_div');
            let res1 = isOverflowing(div1);


        }, 1000)
    }, [dataToEdit])



    useEffect(() => {
        let roles = Cuurent_USER_ROLES();
        let isOrganizer = roles?.includes("QMS Organizer");
        setOrg(isOrganizer)
      
        if (ActiveTBbutton == 1) {
            getTableData()
        }
        else if (ActiveTBbutton == 2) {
            getSortedTaskData()
        }
        // getTableData()
    }, [ActiveTBbutton])



    useEffect(() => {
        filterTableDataBySearchInput(searchInput, tableDataCopy, setTableData);
    }, [searchInput]);

    useEffect(() => {
        handleProgressChange({
            ActiveTBbutton,
            progress,
            userSwitch,
            getTableData,
            getFilteredData,
            getPersonalFilterData,
            fetchData,
            Url,
            setTableData,
            setTableDataCopy,
        });
    }, [progress]);


    var titleStyle = {
        borderRight: "1px solid rgb(198 194 194)",
        // cursor: "pointer",
    }
    const options = [
        { value: 'Completed', label: 'Completed' },
        { value: 'In Progress', label: 'In Progress' },
        { value: 'Not Started', label: 'Not Started' }
    ]

       useEffect(() => {
        SortingToggle(sortedData, setSortedData, isAscendingPend, setIsAscendingPend);
        SortingToggle2(sortedData, setSortedData, isAscendingComp, setIsAscendingComp);
        SortingToggle3(sortedData, setSortedData, isAscendingOver, setIsAscendingOver);
    }, []);


    const lottieStyle = {
        width: "90%",
        height: "140px",
        margin: "0px auto"
    }

    const columns = [

        {
            title: <p>TASK NAME</p>,
            field: "taskname",
            sorting: false,
            rowSpan: 2,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle, position: 'relative' }} className=" taskboard-table-row-data tb-task-name-row">

                        <span className='tb-ellipsis' style={{ width: 360 }}>
                            {rowData?.taskName.substring(0, 1).toUpperCase() + rowData?.taskName.substring(1)}
                        </span>
                        {
                            <div className='tb-task-name-tooptip'>
                                {rowData?.taskName.substring(0, 1).toUpperCase() + rowData?.taskName.substring(1)}
                            </div>}
                    </div>
                );
            },
        },
        {
            title: <p>ASSIGNED DATE</p>,
            field: "assigneddate",
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle }}
                        className="taskboard-table-row-data">

                        <div className=''>

                            {moment(rowData?.parsedAssignedDate, 'DD-MMM-YYYY')?.format('DD/MM/YYYY')}
                        </div>
                    </div>
                );
            },
        },
        {
            title: <p>ETA</p>,
            field: "eta",
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle }} className="taskboard-table-row-data">
                        <span className='' style={{ width: 80 }}>
                            {moment(rowData?.parsedEtaDate, 'DD-MMM-YYYY')?.format('DD/MM/YYYY')}
                        </span>
                    </div>
                );
            },
        },
        {
            title: <p>COMPLETED DATE</p>,
            field: "des_attach",
            sorting: false,
            render: (rowData) => (
                <div style={{ ...titleStyle }} className="taskboard-table-row-data">
                    {rowData?.parsedClosingDate ? <span className='' style={{ width: 80 }}>
                        {moment(rowData?.parsedClosingDate, 'DD-MMM-YYYY')?.format('DD/MM/YYYY')}
                    </span> : "Not Available"}

                </div>
            ),
        },
        {
            title: <p>PROGRESS</p>,
            field: "t_status",
            sorting: false,
            render: (rowData) => (
                <div style={{ ...titleStyle }} className="taskboard-table-row-data">
                    {rowData?.taskStatus}
                </div>
            ),
        },
        {
            title: <p>ACTIONS</p>,
            field: "mom",
            sorting: false,
            render: (rowData) => (
                <div style={{ cursor: 'pointer' }} className="taskboard-table-row-data tb-action-container">
                    <div className='tb-icon-btn-cont' onClick={() => {
                        setIsView(true); getActionItemDataById(
                            rowData?.actionItemId,
                            fetchData,
                            setTaskStatus,
                            setTaskDetailModal,
                            setTaskError,
                            setDataToEdit,
                            setActualData,
                            setLoading,
                            document.getElementById.bind(document),
                            adjustTextareaHeight1
                        )
                    }}><BsEye size={12} /></div>
                    <div className='tb-icon-btn-cont' onClick={() => {
                        getActionItemDataById(
                            rowData?.actionItemId,
                            fetchData,
                            setTaskStatus,
                            setTaskDetailModal,
                            setTaskError,
                            setDataToEdit,
                            setActualData,
                            setLoading,
                            document.getElementById.bind(document),
                            adjustTextareaHeight1
                        )
                    }}> <SlPencil size={12} /></div>
                    <div className='tb-text-btn-cont' onClick={() => {
                        navigateToMeeting(rowData?.scheduleMeeting?.mid, setViewPastMeeting,
                            setFromPastMeeting,
                            navigate); setNavFromTBoard("navFromTaskList")
                    }}>View MOM</div>
                </div>
            ),
        },
    ];

    const columnsForOrg = [
        // {
        //     title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>SR.NO</p>,
        //     field: "srno",
        //     sorting: false,
        //     render: (rowData) => {
        //         return (
        //             <div style={{ ...titleStyle, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '10px' }} className="taskboard-table-row-data">
        //                 {rowData?.actionItemId}
        //             </div>
        //         );
        //     },
        // },
        {
            title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>TASK NAME</p>,
            field: "taskname",
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle, position: 'relative' }} className=" taskboard-table-row-data tb-task-name-row">

                        <span className='tb-ellipsis' style={{ width: 258 }}>
                            {rowData?.taskName.substring(0, 1).toUpperCase() + rowData?.taskName.substring(1)}                        </span>
                        {
                            <div className='tb-task-name-tooptip'>
                                {rowData?.taskName.substring(0, 1).toUpperCase() + rowData?.taskName.substring(1)}                            </div>}
                    </div>
                );
            },
        },
        {
            title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>ASSIGNED TO</p>,
            field: "assignedTo",
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle, position: 'relative' }} className=" taskboard-table-row-data tb-task-name-row">

                        <span className='tb-ellipsis' style={{ width: 100 }}>
                            {rowData?.assignedTo?.fullName}
                        </span>
                        {
                            <div className='tb-task-name-tooptip'>
                                {rowData?.assignedTo?.fullName}
                            </div>}
                    </div>
                );
            },
        },
        {
            title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>ASSIGNED DATE</p>,
            field: "assigneddate",
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle }}
                        className="taskboard-table-row-data">

                        <div className=''>
                            {moment(rowData?.parsedAssignedDate, 'DD-MMM-YYYY')?.format('DD/MM/YYYY')}
                        </div>
                    </div>
                );
            },
        },
        {
            title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>ETA</p>,
            field: "eta",
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ ...titleStyle }} className="taskboard-table-row-data">
                        <span className='' style={{ width: 80 }}>
                            {moment(rowData?.parsedEtaDate, 'DD-MMM-YYYY')?.format('DD/MM/YYYY')}
                        </span>
                    </div>
                );
            },
        },
        {
            title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>COMPLETED DATE</p>,
            field: "des_attach",
            sorting: false,
            render: (rowData) => (
                <div style={{ ...titleStyle }} className="taskboard-table-row-data">
                    {rowData?.parsedClosingDate ? <span className='' style={{ width: 80 }}>
                        {moment(rowData?.parsedClosingDate, 'DD-MMM-YYYY')?.format('DD/MM/YYYY')}
                    </span> : "Not Available"}
                </div>
            ),
        },
        {
            title: <p style={{ borderRight: "1px solid rgb(198 194 194)", height: '100%', display: 'flex', alignItems: 'center' }}>PROGRESS</p>,
            field: "t_status",
            sorting: false,
            render: (rowData) => (
                <div style={titleStyle} className="taskboard-table-row-data">
                    {rowData?.taskStatus}
                </div>
            ),
        },
        {
            title: <p >ACTIONS</p>,
            field: "mom",
            sorting: false,
            render: (rowData) => (
                <div style={{ cursor: 'pointer' }} className="taskboard-table-row-data tb-action-container">
                    <div className='tb-icon-btn-cont' onClick={() => {
                        setIsView(true); getActionItemDataById(
                            rowData?.actionItemId,
                            fetchData,
                            setTaskStatus,
                            setTaskDetailModal,
                            setTaskError,
                            setDataToEdit,
                            setActualData,
                            setLoading,
                            document.getElementById.bind(document),
                            adjustTextareaHeight1
                        )
                    }}><BsEye /></div>
                    <div className='tb-icon-btn-cont' onClick={() => {
                        getActionItemDataById(
                            rowData?.actionItemId,
                            fetchData,
                            setTaskStatus,
                            setTaskDetailModal,
                            setTaskError,
                            setDataToEdit,
                            setActualData,
                            setLoading,
                            document.getElementById.bind(document),
                            adjustTextareaHeight1
                        )
                    }}> <SlPencil /></div>
                    <div className='tb-text-btn-cont' onClick={() => {
                        navigateToMeeting(rowData?.scheduleMeeting?.mid, setViewPastMeeting,
                            setFromPastMeeting,
                            navigate); setNavFromTBoard("navFromTaskList")
                    }}>View MOM</div>
                </div>
            ),
        },
    ];

  

    const handleEmpChangeWrapper = (selectedOption) => {
        handleEmpChange(selectedOption, {
            setFilterValue,
            setSelectedEmp,
            setLoading,
            GET,
            Url,
            token,
            taskCount,
            setTaskCount,
            taskPercentage,
            setTaskPercentage,
            setAdminTaskDue,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal,
        });
    };

    const handleStatusChange = (selectedOption) => {
        exportedHandleStatusChange(selectedOption, { setTaskError, setDataToEdit, dataToEdit });
    };

    return (
      <div className="taskboard-main-div">
        <div
          className={
            ActiveTBbutton == 2
              ? "taskboard-hearder-item-container-toggle"
              : "taskboard-hearder-item-container"
          }
        >
          <div
            className={
              ActiveTBbutton == 1
                ? "taskboard-btn-container-taskList"
                : "taskboard-btn-container"
            }
          >
            <div
              className="taskboard-header-btn2"
              onClick={() => setActiveTBbutton(2)}
              style={{
                borderBottom: ActiveTBbutton == 2 ? "2px solid #00ADEE" : "",
                color: ActiveTBbutton == 2 ? "#00ADEE" : "gray",
              }}
            >
              Task Board
            </div>

            <div
              className="taskboard-header-btn1"
              onClick={() => setActiveTBbutton(1)}
              style={{
                borderBottom: ActiveTBbutton == 1 ? " 2px solid #00ADEE" : "",
                color: ActiveTBbutton == 1 ? "#00ADEE" : "gray",
              }}
            >
              Task List
            </div>

            <div
              className="taskboard-header-btn3"
              onClick={() => setActiveTBbutton(3)}
              style={{
                borderBottom: ActiveTBbutton == 3 ? "2px solid #00ADEE" : "",
                color: ActiveTBbutton == 3 ? "#00ADEE" : "gray",
              }}
            >
              Charts
            </div>
          </div>

          <div
            style={{
              display: "flex",
              width: "70%",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            {ActiveTBbutton == 1 && (
              <div className="searchAndDrop">
                <Select
                  isSearchable={false}
                  options={filterProgress}
                  styles={{
                    ...customStyles,
                    control: (provided, state) => ({
                      ...customStyles.control(provided, state),
                      width: 117,
                    }),
                  }}
                  value={progress}
                  onChange={(e) => {
                    setProgress(e);
                  }}
                />
              </div>
            )}
            {ActiveTBbutton == 1 && (
              <div className="serchbox">
                <BsSearch fill="#999999" />
                <input
                  type="text"
                  placeholder="Search by Task"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
              </div>
            )}
          </div>

          {org && ActiveTBbutton !== 3 && (
            <div
              className="toggleDiv"
              style={{
                left: ActiveTBbutton == 2 ? "52.5rem" : "0rem",
                top: ActiveTBbutton == 2 && "-25px",
              }}
            >
              <div className="view-switch">
                <span
                  className="User-switch"
                  style={{
                    backgroundColor: userSwitch ? "#00ADEE" : "#fff",
                    color: userSwitch ? "#fff" : "#00ADEE",
                  }}
                  onClick={() =>
                    handleUserSwitch(
                      ActiveTBbutton,
                      setUserSwitch,
                      getSortedTaskData,
                      getTableData
                    )
                  }
                >
                  Organiser
                </span>
                <span
                  className="org-switch"
                  style={{
                    backgroundColor: !userSwitch ? "#00ADEE" : "#fff",
                    color: !userSwitch ? "#fff" : "#00ADEE",
                  }}
                  onClick={() =>
                    handleOrgSwitch(
                      ActiveTBbutton,
                      setUserSwitch,
                      getPerson,
                      getAdminTaskList
                    )
                  }
                >
                  User
                </span>
              </div>
            </div>
          )}
        </div>

        {ActiveTBbutton == 1 ? (
          <div className="taskboard-body-container1">
            {org ? (
              <div className="taskboard-table-org-container tsb-table">
                <TaskboardTable data={tableData} columns={columnsForOrg} />
              </div>
            ) : (
              <div className="taskboard-table-container tsb-table">
                <TaskboardTable data={tableData} columns={columns} />
              </div>
            )}
          </div>
        ) : ActiveTBbutton == 2 ? (
          <div className="taskboard-body-container2">
            <div className="taskboard-body-all-container">
              <div className="taskboard-title-text1">
                In Progress ({sortedData?.PendingTask?.length}){" "}
                <BiSortAlt2
                  onClick={() =>
                    SortingToggle(
                      sortedData,
                      setSortedData,
                      isAscendingPend,
                      setIsAscendingPend
                    )
                  }
                  size={20}
                  style={{ cursor: "pointer" }}
                  color="orange"
                />
              </div>
              {
                <div
                  id="inProgress"
                  className="taskboard-body-inprogress-container"
                >
                  {sortedData?.PendingTask?.length != 0 ? (
                    sortedData?.PendingTask?.map((i) => {
                      return (
                        <TaskCard
                          task={i}
                          onClick={() =>
                            getActionItemDataById(
                              i?.actionItemId,
                              fetchData,
                              setTaskStatus,
                              setTaskDetailModal,
                              setTaskError,
                              setDataToEdit,
                              setActualData,
                              setLoading,
                              document.getElementById.bind(document),
                              adjustTextareaHeight1
                            )
                          }
                        />
                      );
                    })
                  ) : (
                    <div className="NoData-class">Task Not Found</div>
                  )}
                </div>
              }
            </div>
            <div className="taskboard-body-all-container">
              <div className="taskboard-title-text2">
                Completed ({sortedData?.CompletedTask?.length}){" "}
                <BiSortAlt2
                  size={20}
                  color="green"
                  onClick={() =>
                    SortingToggle2(
                      sortedData,
                      setSortedData,
                      isAscendingComp,
                      setIsAscendingComp
                    )
                  }
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div
                id="completed"
                className=" taskboard-body-inprogress-container"
              >
                {sortedData?.CompletedTask?.length !== 0 ? (
                  sortedData?.CompletedTask?.map((i) => {
                    return (
                      <TaskCard
                        task={i}
                        onClick={() =>
                          getActionItemDataById(
                            i?.actionItemId,
                            fetchData,
                            setTaskStatus,
                            setTaskDetailModal,
                            setTaskError,
                            setDataToEdit,
                            setActualData,
                            setLoading,
                            document.getElementById.bind(document),
                            adjustTextareaHeight1
                          )
                        }
                      />
                    );
                  })
                ) : (
                  <div className="NoData-class">Task Not Found</div>
                )}
              </div>
            </div>
            <div className="taskboard-body-all-container">
              <div className="taskboard-title-text3">
                Overdue ({sortedData?.OverDueTask?.length}){" "}
                <BiSortAlt2
                  size={20}
                  color="#D7004B"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    SortingToggle3(
                      sortedData,
                      setSortedData,
                      isAscendingOver,
                      setIsAscendingOver
                    )
                  }
                />
              </div>
              <div id="overDue" className="taskboard-body-inprogress-container">
                {sortedData?.OverDueTask?.length !== 0 ? (
                  sortedData?.OverDueTask?.map((i) => {
                    return (
                      <TaskCard
                        task={i}
                        onClick={() =>
                          getActionItemDataById(
                            i?.actionItemId,
                            fetchData,
                            setTaskStatus,
                            setTaskDetailModal,
                            setTaskError,
                            setDataToEdit,
                            setActualData,
                            setLoading,
                            document.getElementById.bind(document),
                            adjustTextareaHeight1
                          )
                        }
                      />
                    );
                  })
                ) : (
                  <div className="NoData-class">Task Not Found</div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="taskboard-body-container3">
            {/* ==========================================================================chart integration======================================================================== */}
            <div className="mainChartsContainer">
              <div className="chartdiv">
                <div className="titleOfCharts">
                  <span style={{ fontWeight: "600" }}>TASK STATUS</span>

                  {org && (
                    <div className="dropdownDiv">
                      <span style={{ paddingRight: "5px" }}> Employee :</span>
                      <Select
                        isSearchable={true}
                        options={employeeOptions}
                        styles={{
                          ...customStyles,
                          menu: (provided, state) => ({
                            ...provided,
                            maxHeight: "170px",
                            overflowY: "scroll",
                          }),
                          control: (provided, state) => ({
                            ...customStyles.control(provided, state),
                            // height: 25,
                            width: 150,
                          }),
                        }}
                        value={selectedEmp}
                        onChange={(e) => handleEmpChangeWrapper(e)}
                        data-testid="Employee"
                      />
                      {selectedEmp.value !== "All" && (
                        <button
                          onClick={() =>
                            handleClearSelection({
                              setSelectedEmp,
                              handleEmpChangeWrapper,
                              setFilterValue,
                            })
                          }
                          className="clearSelection"
                          data-testid="clear-selection-button"
                        >
                          <IoMdClose />
                        </button>
                      )}
                    </div>
                  )}
                  {
                    <div className="dropdownDiv">
                      <span style={{ paddingRight: "5px" }}>Filter :</span>
                      <Select
                        isSearchable={true}
                        options={UserFilterOptions}
                        value={filterValue}
                        styles={{
                          ...customStyles,
                          menu: (provided, state) => ({
                            ...provided,
                            maxHeight: "170px",
                            overflowY: "scroll",
                          }),
                        }}
                        onChange={(e) =>

                        // console.log("Filter w", e)
                          handleUserFilterValueChange(
                            e,
                            setFilterValue
                          )
                        }
                      />
                    </div>
                  }
                </div>
                <div className="bindtogether">
                  <div style={{ marginTop: "20px" }} className="chartDiv">
                    {allZeros(dataset.series) ? (
                      <Lottie animationData={animation} style={lottieStyle} />
                    ) : (
                      <div className="chart-container">
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={dataset}
                        />
                      </div>
                    )}
                  </div>
                  <div className="cardsDiv">
                    <div
                      className="inner-cards"
                      style={{ borderLeft: "4px solid #FF8B16" }}
                    >
                      <span style={{ fontWeight: "600", fontSize: "22px" }}>
                        {taskCount?.NotStartedCount}
                      </span>
                      <span style={{ color: "#FF8B16", fontWeight: "600" }}>
                        Not Started
                      </span>
                    </div>
                    <div
                      className="inner-cards"
                      style={{ borderLeft: "4px solid #00ADEE" }}
                    >
                      <span style={{ fontWeight: "600", fontSize: "22px" }}>
                        {taskCount?.PendingTaskCount}
                      </span>
                      <span style={{ color: "#00ADEE", fontWeight: "600" }}>
                        In Progress
                      </span>
                    </div>
                    <div
                      className="inner-cards"
                      style={{ borderLeft: "4px solid #22C373" }}
                    >
                      <span style={{ fontWeight: "600", fontSize: "22px" }}>
                        {taskCount?.CompletedTaskCount}
                      </span>
                      <span style={{ color: "#22C373", fontWeight: "600" }}>
                        Completed
                      </span>
                    </div>
                    <div
                      className="inner-cards"
                      style={{ borderLeft: "4px solid #EB495D" }}
                    >
                      <span style={{ fontWeight: "600", fontSize: "22px" }}>
                        {taskCount?.OverDueTaskCount}
                      </span>
                      <span style={{ color: "#EB495D", fontWeight: "600" }}>
                        Overdue
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rigthdueDiv">
                <div className="taskboard-body-all-container">
                  <div
                    className="taskboard-title-text3"
                    style={{ justifyContent: "start" }}
                  >
                    Overdue ({AdminDueTask?.length})
                  </div>
                  <div
                    id="overDue"
                    className=" taskboard-body-inprogress-container"
                  >
                    {AdminDueTask?.length !== 0 ? (
                      AdminDueTask?.map((i) => {
                        return <TaskCard task={i} Status={"No"} />;
                      })
                    ) : (
                      <div className="NoData-class">Task Not Found</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          isOpen={TaskDetailModal}
          onRequestClose={()=>handleRequestClose(setIsView, setTaskDetailModal)}
          style={modalStyles}
          contentLabel="Example Modal"
        >
          <div className="inner-task-deatil-modal">
            <div
              className="tb-modal-close-btn"
              onClick={()=>handleRequestClose(setIsView, setTaskDetailModal)}
            >
              <span>X</span>
            </div>

            <div className="tb-modal-info-cont">
              <div className="task-modal-info-row1">
                <div
                  className="tb-modal-header-container tb-modal-header"
                  style={{ position: "relative" }}
                >
                  <h4 id="MeetingSub_div">
                    <b>
                      {" "}
                      <PiCircle size={15} />
                    </b>{" "}
                    {dataToEdit?.taskName.substring(0, 1).toUpperCase() +
                      dataToEdit?.taskName.substring(1)}{" "}
                  </h4>
                  {dataToEdit?.taskName && (
                    <div className="tb-modal-header-tool-tip">
                      {dataToEdit?.taskName.substring(0, 1).toUpperCase() +
                        dataToEdit?.taskName.substring(1)}
                    </div>
                  )}
                </div>
              </div>
              <div className="tb-names-cont">
                <div className="task-modal-info-row1 " style={{ width: "50%" }}>
                  <div style={{ color: "black" }}> Assigned To : </div>
                  <div style={{ color: "#999999", paddingLeft: "5px" }}>
                    {dataToEdit?.assignedTo?.fullName}{" "}
                  </div>
                </div>
                <div className="task-modal-info-row1" style={{ width: "50%" }}>
                  <div style={{ color: "black" }}> Assigned By : </div>
                  <div style={{ color: "#999999", paddingLeft: "5px" }}>
                    {dataToEdit?.assignedBy?.fullName}{" "}
                  </div>
                </div>
              </div>

              {taskStatus !== "Completed" ? (
                <div className="task-modal-info-row2">
                  <div>
                    {" "}
                    <div style={{ marginBottom: "6px" }}> Assigned Date </div>
                    <CustomDatePicker
                      selectedDate={dataToEdit.formattedAssignedDate}
                      onDateChange={(date) =>
                        setDataToEdit({
                          ...dataToEdit,
                          formattedAssignedDate: date,
                        })
                      }
                      isDisabled={true}
                      customStyles={datePickerStyles}
                    />
                  </div>
                  <div>
                    <div style={{ marginBottom: "6px" }}> ETA </div>

                    <CustomDatePicker
                      selectedDate={dataToEdit.formattedEtaDate}
                      onDateChange={(date) =>
                        setDataToEdit({ ...dataToEdit, formattedEtaDate: date })
                      }
                      isDisabled={true}
                      customStyles={datePickerEtaStyles}
                    />
                  </div>

                  <div>
                    <div style={{ marginBottom: "6px" }}>Progress </div>
                    <StatusSelector
                      isView={isView}
                      options={options}
                      customStyles={customStyles}
                      dataToEdit={dataToEdit}
                      handleStatusChange={handleStatusChange}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <div className="task-modal-info-row2">
                    <div className="taskBoardEle">
                      {" "}
                      <div style={{ marginBottom: "6px" }}>
                        {" "}
                        Assigned Date :
                      </div>
                      <CustomDatePicker
                        selectedDate={dataToEdit.formattedAssignedDate}
                        onDateChange={(date) =>
                          setDataToEdit({
                            ...dataToEdit,
                            formattedAssignedDate: date,
                          })
                        }
                        isDisabled={true}
                        customStyles={datePickerStyles}
                      />
                    </div>
                    <div className="taskBoardEle" style={{ gap: "45px" }}>
                      <div style={{ marginBottom: "6px" }}> ETA :</div>

                      <CustomDatePicker
                        selectedDate={dataToEdit.formattedEtaDate}
                        onDateChange={(date) =>
                          setDataToEdit({
                            ...dataToEdit,
                            formattedEtaDate: date,
                          })
                        }
                        isDisabled={true}
                        customStyles={datePickerStyles}
                      />
                    </div>
                  </div>
                  <div className="task-modal-info-row2">
                    <div className="taskBoardEle" style={{ gap: "10px" }}>
                      <div style={{ marginBottom: "6px" }}>
                        Completed Date :{" "}
                      </div>

                      <CustomDatePicker
                        selectedDate={dataToEdit.formattedClosingDate}
                        onDateChange={(date) =>
                          setDataToEdit({
                            ...dataToEdit,
                            formattedEtaDate: date,
                          })
                        }
                        isDisabled={true}
                        customStyles={datePickerStyles}
                      />
                    </div>

                    <div className="taskBoardEle">
                      <div style={{ marginBottom: "6px" }}>Progress :</div>
                      <StatusSelector
                        isView={isView}
                        options={options}
                        customStyles={customStyles}
                        dataToEdit={dataToEdit}
                        handleStatusChange={handleStatusChange}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div style={{ marginBottom: "6px" }}>Description </div>

              <div className="field">
                <div
                  className="field  agenda-field border"
                  style={{
                    backgroundColor: isView ? "#FAFAFA" : "",
                    minHeight: isView ? "" : "40px",
                    width: "100%",
                    padding: 0,
                    fontSize: "14px",
                    marginBottom: "10px",
                  }}
                >
                  <textarea
                    disabled={isView}
                    id="taskDescription"
                    onChange={(e) => {
                      handleDescriptionChange(e, {
                        setDataToEdit,
                        setTaskError,
                        dataToEdit,
                      });
                      adjustTextareaHeight();
                    }}
                    className="EPM-disscussion-cont2"
                  >
                    {dataToEdit?.taskDescription}
                  </textarea>
                </div>
                <span className="TaskDescError">{taskError}</span>
              </div>

              <div style={{ marginBottom: "6px" }}>Attachments </div>
              <div style={{ overflowX: 'scroll' }} className='TB-Attachmwnt-cont' onClick={(e) => {
                            if (isView) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }}
                            onMouseOver={(e) => {
                                if (isView) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
                            }}
                            onDragStart={(e) => {
                                if (isView) {
                                    e.stopPropagation();
                                    e.preventDefault(); // Disable drag and drop

                                }
                            }}  >
                            {/* handleFormChange, setFormData, flow, actualData, formData, isDisabled */}
                            <FileUpload
                             handleFormChange={handleEditChange}
                             setFormData={setDataToEdit}
                             flow={"edit_task"}
                             actualData={actualData}
                            formData={dataToEdit}
                            isDisabled={isView}
                            />
                        </div>
              <div
                style={{ overflowX: "scroll" }}
                className="TB-Attachmwnt-cont"
                onClick={(e) => handleDivEvent(e, isView)}
                onMouseOver={(e) => handleDivEvent(e, isView)}
                onDragStart={(e) => handleDivEvent(e, isView)}
              ></div>

              {!isView && (
                <div className="task-modal-ok-btn">
                  <button
                    onClick={() =>
                      handleEditTask(
                        dataToEdit,
                        setLoading,
                        setTaskError,
                        PUT, // Your PUT function
                        Url, // URL object
                        token,
                        moment, // Your moment library
                        ActiveTBbutton,
                        getTableData,
                        getSortedTaskData,
                        setOpenSuccessModal,
                        setSuccessMessage,
                        setTaskDetailModal,
                        setSessionExpiredModal,
                        setFailMessage,
                        setOpenFailModal,
                        setSearchInput,
                        setProgress
                      )
                    }
                  >
                    OK
                  </button>
                </div>
              )}
            </div>
            <div
              className="tb-modal-download-btn"
              data-testid="tb-modal-download-btn"
              onClick={() => {
                navigateToMeeting(
                  dataToEdit?.scheduleMeeting?.mid,
                  setViewPastMeeting,
                  setFromPastMeeting,
                  navigate
                );
                setNavFromTBoard("navFromTaskBoard");
              }}
            >
              <button>
                <BsEye size={13} />
                MOM
              </button>
            </div>
          </div>
        </Modal>

        <FailModal
          openFailModal={openFailModal}
          setOpenFailModal={setOpenFailModal}
          failMessage={failMessage}
          setFailMessage={setFailMessage}
          recallFunctionOnOk={() => handleCloseFailModel(setOpenFailModal)}
          recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)}
        />

        <FailModal
          openFailModal={sessionExpiredModal}
          setOpenFailModal={setSessionExpiredModal}
          failMessage={failMessage}
          setFailMessage={setFailMessage}
          recallFunctionOnOk={() =>
            handleSessionExpClose(sessionStorage, navigate, setActive)
          }
          recallFunctiononClose={() =>
            handleSessionExpClose(sessionStorage, navigate, setActive)
          }
        />
        <SuccessModal
          openSuccessModal={openSuccessModal}
          setOpenSuccessModal={setOpenSuccessModal}
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
          recallFunctionOnOk={()=>navigateAfterSubmit(navigate)}
          recallFunctionOnClose={()=>navigateAfterSubmit(navigate)}
        />
      </div>
    );
}

export default TaskBoard